import React from "react";
import styled from "styled-components";
import GoBackIcon from "@assets/img/go-back-icon.svg";
import GoBackIconActive from "@assets/img/go-back-icon-active.svg";
import { useNavigate } from "react-router-dom";
import { useHover } from "@src/hooks/useHover";

export const TopActionButton = styled.button<{
  hoverBgColor?: string;
  hoverColor?: string;
  width?: string;
  color?: string;
}>`
  outline: none;
  background-color: ${({ theme }): string => theme.colors.darkGray};
  border: 1px solid
    ${({ theme, color }): string => color || theme.colors.yellow};
  color: ${({ theme, color }): string => color || theme.colors.yellow};

  font-weight: bold;
  min-width: ${({ width }): string => width || "90px"};
  height: 30px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  &:hover {
    background-color: ${({ theme, hoverBgColor }): string =>
      hoverBgColor ? hoverBgColor : theme.colors.yellow};
    color: ${({ theme, hoverColor }): string =>
      hoverColor ? hoverColor : theme.colors.black};
  }
`;

const GoBackButton: React.FC<{ navigateTo: string; label: string }> = ({
  navigateTo,
  label,
}) => {
  const { handleMouseEnter, handleMouseLeave, isHovered } = useHover();
  const navigate = useNavigate();
  return (
    <TopActionButton
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        borderRadius: 20,
      }}
      onClick={() => navigate(navigateTo)}
      width="100px"
    >
      <img
        src={isHovered ? GoBackIconActive : GoBackIcon}
        alt="Go Back"
        style={{ width: 15, objectFit: "contain" }}
      />
      {label}
    </TopActionButton>
  );
};

export default GoBackButton;
